import axios from 'axios'
import appConfig from '@/config/index'


const instance = axios.create()
instance.defaults.baseURL = appConfig.baseUrl.dev;
instance.defaults.validateStatus = function (status) {
  return status >= 0 && status < 600;
}

// 请求拦截
instance.interceptors.request.use(config => {
  if ((config.url.indexOf("/account/token") < 0)) {
    config.headers["Authorization"] = "bearer " + window.localStorage.getItem("token");
  }
  return config
}, error => {
  return Promise.reject(error)
})
// 响应拦截
instance.interceptors.response.use(res => {
  if (res.status == 401) {
    window.location.href = window.location.pathname + "#/login"
  } else if (res.status == 403) {
    window.location.href = window.location.pathname + "#/login"
  }
  return res
}, error => {
  return Promise.reject(error)
})

export default instance



// WEBPACK FOOTER //
// ./src/libs/axios.js